import types from 'constants/actionTypes';
import { combineReducers } from 'redux';

const initialState = {
  email: '',
  enabled: true,
};

const base = (state, { type, payload }) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (type) {
    case types.FETCH_USER_SETTING_REQUEST_SUCCESS:
    case types.UPDATE_USER_SETTING_REQUEST_SUCCESS:
      return payload;
    case types.TOGGLE_USER_SETTING:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default combineReducers({
  base,
});
